import { takeLatest, put, select } from 'redux-saga/effects';
import {
  GAME_SCROLL_SAVE_REQUEST,
  GAME_SCROLL_SAVE_SUCCESS,
  GAME_SCROLL_USE_REQUEST,
  GAME_SCROLL_CLEAR,
} from '../constants/game';

function* scrollSave() {
  let at = 0;
  let scroller = document.querySelector('#game_content');
  if (scroller) {
    at = scroller.scrollTop;
  }

  yield put({
    type: GAME_SCROLL_SAVE_SUCCESS,
    at,
  });
}

function* scrollUse({ action }) {
  let at = yield select(state => state.game.at);
  if (action === 'POP') {
    yield put({
      type: GAME_SCROLL_CLEAR,
    });
  } else {
    at = 0;
  }
  const scroller = document.querySelector('#game_content');
  if (scroller) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scroller.scrollTop = at;
      });
    });
  }
}

export function* watchGameScrollSave() {
  yield takeLatest(GAME_SCROLL_SAVE_REQUEST, scrollSave);
}

export function* watchGameScrollUse() {
  yield takeLatest(GAME_SCROLL_USE_REQUEST, scrollUse);
}
